import { TickFormatStop } from "plotly.js"

export const tickFormatStops: Array<Partial<TickFormatStop>> = [
  {
    "dtickrange": [null, 1000],
    // "value": "%d/%m/%y %H:%M:%S.%L ms"
    "value": "%d/%m/%y %H:%M:%S"
  },
  {
    "dtickrange": [1000, 60000],
    "value": "%d/%m/%y %H:%M:%S"
  },
  {
    "dtickrange": [60000, 3600000],
    "value": "%d/%m/%y %H:%M"
  },
  {
    "dtickrange": [3600000, 86400000],
    "value": "%d/%m/%y %H:%M"
  },
  {
    "dtickrange": [86400000, 604800000],
    "value": "%d/%m/%Y"
  },
  {
    "dtickrange": [604800000, "M1"],
    "value": "%e. %b %Y"
  },
  {
    "dtickrange": ["M1", "M12"],
    "value": "%b '%Y"
  },
  {
    "dtickrange": ["M12", null],
    "value": "%Y"
  }
]